import { IdVerification, UpdateIdVerification } from "../types";
import { api } from "./api";
import { patientApi } from "./patientsApi";

export const idVerificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updatePatientIdVerification: builder.mutation<
      IdVerification,
      UpdateIdVerification
    >({
      query: ({ id, ...rest }) => ({
        method: "PUT",
        url: `/api/id-verification/${id}`,
        body: rest,
      }),
      onQueryStarted: async (_, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          patientApi.util.updateQueryData(
            "getPatientById",
            data.patient_id,
            (draft) => {
              Object.assign(draft, { id_verified: data.verified_at != null });
            }
          )
        );
      },
    }),
  }),
});

export const { useUpdatePatientIdVerificationMutation } = idVerificationApi;
